import QuizConnectionAnswer from './QuizConnectionAnswer';

export default QuizConnectionAnswer;
